module.exports = __webpack_public_path__ + "img/chinesecompany210.14c9fff9.png";